import React from "react";
import { useTranslation } from "react-i18next";

interface PlanModeProgressProps {
  step: 1 | 2 | 3 | 4 | 5;
}

const STEPS = [
  { num: 1, labelKey: "pages.chat.planStepExchanges" },
  { num: 2, labelKey: "pages.chat.planStepPlan" },
  { num: 3, labelKey: "pages.chat.planStepConfigure" },
  { num: 4, labelKey: "pages.chat.planStepGenerated" },
];

const PlanModeProgress: React.FC<PlanModeProgressProps> = ({ step }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center gap-2 mb-3 px-2 py-2 bg-gray-50 rounded-lg border border-gray-200">
      {STEPS.map((s, i) => {
        const isActive = step === s.num;
        const isDone = step > s.num;
        return (
          <React.Fragment key={s.num}>
            <div className="flex items-center gap-2">
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium ${
                  isDone
                    ? "bg-green-500 text-white"
                    : isActive
                    ? "bg-purple-500 text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {isDone ? "✓" : s.num}
              </span>
              <span
                className={`text-xs ${isActive ? "font-medium text-gray-800" : "text-gray-500"}`}
              >
                {t(s.labelKey)}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <span
                className={`flex-1 h-px max-w-[40px] ${
                  step > s.num ? "bg-green-500" : "bg-gray-300"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PlanModeProgress;
